/**
 * YovoTrip color tokens — sourced from Figma Color System (node 5765:128524).
 * Use these primitives; avoid hardcoded hex in components.
 */
const colors = {
  yovoRed: {
    100: '#FFDEE5',
    200: '#FF93AC',
    300: '#E9496E',
    400: '#CF2048',
    500: '#C0042F',
  },
  secondary: {
    100: '#D9E6E9',
    200: '#9EB5BB',
    300: '#5F777E',
    400: '#3A5962',
    500: '#122C34',
  },
  tertiary: {
    100: '#E4E6F7',
    200: '#BCBFE3',
    300: '#7D82B8',
    400: '#444B94',
  },
  accent: {
    100: '#FFEFE4',
    200: '#D7B49E',
    300: '#AF734E',
  },
  background: {
    bg01: '#FDFDFE',
    bg02: '#FAFAFD',
    bg03: '#F3F3F7',
    bg04: '#E8E8EE',
  },
  divider: {
    d01: '#FAFAFD',
    d02: '#F3F3F7',
    d03: '#E8E8EE',
    d04: '#DAD9E0',
  },
  neutral: {
    white: '#FDFDFE',
    100: '#FAFAFD',
    200: '#F3F3F7',
    300: '#E8E8EE',
    400: '#DAD9E0',
    500: '#AAA8B7',
    600: '#686A7A',
    700: '#535462',
    800: '#434151',
    900: '#252637',
    1000: '#1A1827',
    black: '#0C0A12',
  },
  semantic: {
    green: {
      100: '#D6FFDB',
      200: '#93E19C',
      300: '#4DAA57',
      400: '#167620',
    },
    yellow: {
      100: '#FFECCB',
      200: '#FFCB6C',
      300: '#FFA400',
      400: '#7A4E00',
    },
    red: {
      100: '#FFB0B7',
      200: '#FA5B73',
      300: '#E22E49',
      400: '#CE001F',
    },
  },
};

/** MUI palette mapping built from design tokens */
export const palette = {
  primary: {
    main: colors.neutral[1000],
    light: colors.neutral[900],
    dark: colors.neutral.black,
    contrastText: colors.neutral.white,
  },
  secondary: {
    main: colors.secondary[500],
    light: colors.secondary[200],
    dark: colors.secondary[400],
    contrastText: colors.neutral.white,
  },
  error: {
    main: colors.semantic.red[300],
    light: colors.semantic.red[100],
    dark: colors.semantic.red[400],
    contrastText: colors.neutral.white,
  },
  warning: {
    main: colors.semantic.yellow[300],
    light: colors.semantic.yellow[100],
    dark: colors.semantic.yellow[400],
    contrastText: colors.neutral.black,
  },
  success: {
    main: colors.semantic.green[300],
    light: colors.semantic.green[100],
    dark: colors.semantic.green[400],
    contrastText: colors.neutral.white,
  },
  info: {
    main: colors.tertiary[400],
    light: colors.tertiary[100],
    dark: colors.tertiary[300],
    contrastText: colors.neutral.white,
  },
  text: {
    primary: colors.neutral[900],
    secondary: colors.neutral[600],
    disabled: colors.neutral[500],
  },
  background: {
    default: colors.background.bg02,
    paper: colors.neutral.white,
  },
  divider: colors.divider.d04,
  /** Extended tokens accessible via theme.palette.tokens */
  tokens: colors,
};

export default colors;
